import React from "react"

import KYCCompleteImage from "../../../assets/images/gif/kyc-complete.gif"

const KYCComplete = () => {
  return (
    <>
      <div className="kyc-complete-wrapper">
        <img height={"250px"} src={KYCCompleteImage} alt="" />
        <h5 className="title my-3">Thank You!</h5>
        <p>
          Your profile update process has been successfully completed and is
          currently under review. You will receive an update within 48 hours.
        </p>
      </div>
    </>
  )
}

export default KYCComplete
